import { filter } from 'rxjs/operators';
import { Router } from '@angular/router';
import { Component, HostListener, OnInit } from '@angular/core';
import { UtilService } from '@app/utility/util.service'
import { ApiService } from '@app/utility/api.service'
import { NotiService } from '@app/noti.service';
import { Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

declare var $: any

@Component({
  selector: 'app-simulator',
    templateUrl: './simulator.component.html',
  styleUrls: ['./simulator.component.scss']
})
export class SimulatorComponent implements OnInit {
  debtNotMatch = false
  step: number = 1
  maxStep: number = 3
  maxRefund: number = 1000000

  isSmallScreen = false
  depositAcc: Array<any> = []
  debtAcc: Array<any> = []
  refundList: Array<any> = []

  totalDepositAcc: Array<any> = []
  totalDebtAcc: Array<any> = []

  simConfig: any
  start1 = ""
  end1 = ""
  amount1 = ""

  start2 = ""
  amount2 = ""

  remark1: string = ""
  remark2: string = ""

  bankList:any = []
  lang = "th"

  
  menuEnabled = false

  private notiSubscription: Subscription;

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.isSmallScreen = window.innerWidth < 415 ? true : false
  }

  constructor(
    private router: Router,
    private util: UtilService,
    private api: ApiService,
    private notiService: NotiService,
    private translate: TranslateService
  ) { }

  ngOnDestroy() {
    if(this.notiSubscription){
      this.notiSubscription.unsubscribe();
    }
  }

  async ngOnInit() {
    this.util.ShowWaiting(true)

    let config: any = await this.api.get("master", "configuration")
    let crisisConfig: any = config.filter((c: any) => {
      return c.dpa_name == "CRISIS FLAG"
    })

    let isCrisis: any 
    if (crisisConfig != null && crisisConfig.length > 0 && crisisConfig[0].dpa_crisisflag != null && crisisConfig[0].dpa_crisisflag == true) {
      isCrisis = true
    }
    else {
      isCrisis = false
    }

    let menuList:any = await this.api.get("master", "customerPortalMenuSetting")
    let thisMenu: any = this.util.getMenuObj(menuList, "01", isCrisis)
    if(!thisMenu.show){
      this.util.ShowWaiting(false)
      setTimeout(() => {
        this.router.navigate(["mainmenu/index"])
      }, 500);
      return
    }
    else{
      this.menuEnabled = true
    }

    // let tmpLang = this.util.GetCurrentLang()
    // this.lang = tmpLang.substring(0,2)
    // this.util.SetLanguage(tmpLang)

    this.notiSubscription = this.notiService.message.subscribe(_lang => {
      this.lang = _lang
      this.setRemarkTranslate()
    });

    this.util.InitValidation()
    await this.getSimulateConfig()
    this.bankList = //await this.api.get("master", "bank")
    [
      {
        dpa_bankid: "1",
        dpa_name: "A"
      },
      {
        dpa_bankid: "2",
        dpa_name: "B"
      },
      {
        dpa_bankid: "3",
        dpa_name: "C"
      }
    ]
    this.isSmallScreen = window.innerWidth < 415 ? true : false
    this.addAcc()
    this.util.ShowWaiting(false)
  }

  async getSimulateConfig() {
    this.simConfig = await this.api.get("master", "simulateConfiguration")

    this.simConfig.forEach((c: any) => {
      if (c.dpa_isactive) {
        this.maxRefund = parseInt(c.dpa_value)
      }

      if (c.dpa_enddate == null) {
        this.start2 = c.dpa_startdate
        this.amount2 = parseInt(c.dpa_value).toString()
      }
      else {
        this.start1 = c.dpa_startdate
        this.end1 = c.dpa_enddate
        this.amount1 = parseInt(c.dpa_value).toString()
      }
    });

    this.setRemarkTranslate()
  }

  setRemarkTranslate(){
    let rm1: any = this.translate.get("SimulateProtect1")
    let rm2: any = this.translate.get("SimulateProtect2")

    this.remark1 = rm1.value.replace("{0}", this.util.numberWithCommas(this.maxRefund))
    if(this.lang == "th"){
      this.remark2 = rm2.value.replace("{0}", this.util.transformDate(this.start2, "medium"))
      .replace("{1}", this.util.numberWithCommas(this.amount2))
      // .replace("{2}", this.util.transformDate(this.end1, "medium"))
      // .replace("{3}", this.util.transformDate(this.start2, "medium"))
      // .replace("{4}", this.util.numberWithCommas(this.amount2))
    }
    else{
      this.remark2 = rm2.value.replace("{0}", this.util.numberWithCommas(this.amount2))
      .replace("{1}", this.util.transformDateEn(this.start2, "medium"))
      // .replace("{2}", this.util.transformDateEn(this.end1, "medium"))
      // .replace("{3}", this.util.transformDateEn(this.start2, "medium"))
      // .replace("{4}", this.util.numberWithCommas(this.amount2))
    }
  }

  prevStep() {
    this.step--
  }

  nextStep() {
    if(this.step == 1 && !this.isValidDepositList()){
      this.util.ErrorDialog("กรุณากรอกข้อมูลให้ครบ")
      return
    }
    else if(this.step == 2 && !this.isValidDebtList()){
      this.util.ErrorDialog("กรุณากรอกข้อมูลให้ครบ")
      return
    }
    this.step++

    if(this.step == 2){
      if(this.debtAcc == null || this.debtAcc.length == 0){
        this.addDebt()
      }
    }
    else if (this.step == 3) {
      this.debtNotMatch = false
      this.refundList = []

      for (let i = 0; i < this.totalDepositAcc.length; i++) {
        let debtInDeposit: any = this.totalDebtAcc.filter((debt: any) => {
          return debt.bankName == this.totalDepositAcc[i].bankName
        })

        if(debtInDeposit != null && debtInDeposit.length > 0){
          let r: any = {}
          r.bankName = this.totalDepositAcc[i].bankName
          r.deposit = parseInt(this.totalDepositAcc[i].total) - parseInt(debtInDeposit[0].total)
          r.total = r.deposit > this.maxRefund ? this.maxRefund : r.deposit
          if(r.total < 0){
            r.total = 0
          }
          this.refundList.push(r)
          debtInDeposit[0].matchDeposit = true
        }
        else{
          let r: any = {}
          r.bankName = this.totalDepositAcc[i].bankName
          r.deposit = parseInt(this.totalDepositAcc[i].total)
          r.total = r.deposit > this.maxRefund ? this.maxRefund : r.deposit
          if(r.total < 0){
            r.total = 0
          }
          this.refundList.push(r)
        }
      }

      let debtNotMatchList: any = this.totalDebtAcc.filter((d: any) => {
        return d.matchDeposit != true 
      })
      this.debtNotMatch = debtNotMatchList != null && debtNotMatchList.length > 0
    }
  }

  addAcc() {
    if(!this.isValidDepositList() && this.depositAcc.length != 0){
      this.util.WarningDialog("กรุณากรอกข้อมูลให้ครบ")
      return
    }
    let acc: any = {}
    acc.selected = false
    acc.bankId = ""
    acc.bankType = ""
    acc.amount = null
    acc.shared = false
    acc.percent = null
    acc.percentValid = true
    acc.bankName = ""
    acc.total = null

    this.depositAcc.push(acc)
  }

  deleteAcc(index: number) {
    this.depositAcc.splice(index, 1);
    this.calTotalStep1()
  }

  addDebt() {
    if(!this.isValidDebtList() && this.debtAcc.length != 0){
      this.util.WarningDialog("กรุณากรอกข้อมูลให้ครบ")
      return
    }
    let acc: any = {}
    acc.selected = false
    acc.bankId = ""
    acc.total = null

    this.debtAcc.push(acc)
  }

  deleteDebt(index: number) {
    this.debtAcc.splice(index, 1);
    this.calTotalStep2()
  }

  onBankDepositChange(index: number) {
    let selectedBank: any = this.bankList.filter((b: any) => {
      return b.dpa_bankid == this.depositAcc[index].bankId
    })

    if(selectedBank == null || selectedBank.length == 0){
      this.depositAcc[index].bankName = ""
    }
    else{
      this.depositAcc[index].bankName = selectedBank[0].dpa_name
    }

    if(this.step == 1){
      this.calStep1(index)
    }

    this.step1FocusOut(index)
  }

  onBankDebtChange(index: number) {
    let selectedBank: any = this.bankList.filter((b: any) => {
      return b.dpa_bankid == this.debtAcc[index].bankId
    })

    if(selectedBank == null || selectedBank.length == 0){
      this.debtAcc[index].bankName = ""
    }
    else{
      this.debtAcc[index].bankName = selectedBank[0].dpa_name
    }

    if(this.step == 2){
      this.calStep2(index)
    }

    
    this.step2FocusOut(index)
  }

  calStep1(index: number) {
    let dep: any = this.depositAcc[index]
    if(dep.bankId == "" || dep.amount == null || (dep.shared && (dep.percent == null || dep.percent <= 0))){
      return
    }

    this.totalDepositAcc = []
    this.depositAcc.forEach((dep: any) => {
      if (dep.shared && dep.percent > 0) {
        if(dep.percent >= 100){
          dep.percent = 99.99
        }
        if(typeof(dep.amount) == "string"){
          dep.total = parseInt(dep.amount.replaceAll(",", "")) * dep.percent / 100
        }
        else{
          dep.total = dep.amount * dep.percent / 100
        }
      }
      else {
        if(typeof(dep.amount) == "string"){
          dep.total = dep.amount.replaceAll(",", "")
        }
        else{
          dep.total = dep.amount
        }
      }
  
      let match: any = this.totalDepositAcc.filter((d: any) => {
        return d.bankId == dep.bankId
      })
  
      if (match != null && match.length > 0) {
        let index = this.totalDepositAcc.indexOf(match[0])

        let a = this.totalDepositAcc[index].total
        let b = dep.total

        if(typeof(a) == "string"){
          a = parseInt(this.totalDepositAcc[index].total.replaceAll(",", ""))
        }

        if(typeof(b) == "string"){
          b = parseInt(dep.total.replaceAll(",", ""))
        }
        
        this.totalDepositAcc[index].total =  a + b 
        
      }
      else {
        if(typeof(dep.total) == "string"){
          dep.total = dep.total.replaceAll(",", "")
        }
        this.totalDepositAcc.push(JSON.parse(JSON.stringify(dep)))
      }
    })
  }

  calTotalStep1(){
    this.totalDepositAcc = []
    this.depositAcc.forEach((d: any) => {

      let match: any = this.totalDepositAcc.filter((td: any) => {
        return td.bankId == d.bankId
      })

      if(match != null && match.length > 0){
        let index = this.totalDepositAcc.indexOf(match[0])

        let a = this.totalDepositAcc[index].total
        let b = d.total
        if(typeof(a) == "string"){
          a = parseInt(this.totalDepositAcc[index].total.replaceAll(",", ""))
        }
        
        if(typeof(b) == "string"){
          b = parseInt(d.total.replaceAll(",", ""))
        }

        this.totalDepositAcc[index].total = a + b
      }
      else{
        if(typeof(d.total) == "string"){
          d.total = d.total.replaceAll(",", "")
        }
        this.totalDepositAcc.push(JSON.parse(JSON.stringify(d)))
      }
    })
  }

  calStep2(index: number) {
    let depAc: any = this.debtAcc[index]
    if(depAc.bankId == "" || depAc.total == null){
      return
    }
    else{
      if(typeof(depAc.total) == "string"){
        depAc.total = depAc.total.replaceAll(",", "")
      }
    }

    this.totalDebtAcc = []
    this.debtAcc.forEach((dep: any) => {
      let match: any = this.totalDebtAcc.filter((d: any) => {
        return d.bankId == dep.bankId
      })

      
      let aaa = this.totalDebtAcc
      
  
      if (match != null && match.length > 0) {
        let index = this.totalDebtAcc.indexOf(match[0])
        
        let a = this.totalDebtAcc[index].total
        let b = dep.total
        if(typeof(a) == "string"){
          a = parseInt(this.totalDebtAcc[index].total.replaceAll(",", ""))
        }
        
        if(typeof(b) == "string"){
          b = parseInt(dep.total.replaceAll(",", ""))
        }

        this.totalDebtAcc[index].total = a + b
      }
      else {
        if(typeof(dep.total) == "string"){
          dep.total = dep.total.replaceAll(",", "")
        }
        this.totalDebtAcc.push(JSON.parse(JSON.stringify(dep)))
      }
      
      let bbbb = this.totalDebtAcc
      

      dep.total = (dep.total).toString().replaceAll(",", "").replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    })
  }

  calTotalStep2(){
    this.totalDebtAcc = []
    this.debtAcc.forEach((d: any) => {

      let match: any = this.totalDebtAcc.filter((td: any) => {
        return td.bankId == d.bankId
      })
      
      let bbbb = this.totalDebtAcc
      

      if(match != null && match.length > 0){
        let index = this.totalDebtAcc.indexOf(match[0])
        let a = this.totalDebtAcc[index].total
        let b = d.total
        if(typeof(a) == "string"){
          a = parseInt(this.totalDebtAcc[index].total.replaceAll(",", ""))
        }
        
        if(typeof(b) == "string"){
          b = parseInt(d.total.replaceAll(",", ""))
        }
        this.totalDebtAcc[index].total = a + b
      }
      else{
        if(typeof(d.total) == "string"){
          d.total = d.total.replaceAll(",", "")
        }
        this.totalDebtAcc.push(JSON.parse(JSON.stringify(d)))
      }
      
      
      d.total = (d.total).toString().replaceAll(",", "").replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    })
  }

  goToIndex() {
    this.router.navigate(["mainmenu/index"])
  }

  numberAndDotOnly(event: any){
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode != 44) {
      if(charCode == 46){
        if(event.target.value.indexOf(".") == -1){
          return true
        }
        else{
          // if(event.target.value.length - event.target.value.indexOf(".") > 2){
          //   return false
          // }
          // else{
            return true
          // }
        }
      }
      return false;
    }
    if(event.target.value.indexOf(".") == -1){
      return true
    }
    else{
      // if(event.target.value.length - event.target.value.indexOf(".") > 2){
      //   return false
      // }
      // else{
        return true
      // }
    }
  }

  isValidDepositList() {
    if(this.depositAcc == null || this.depositAcc.length == 0){
      return false
    }
    let isValid = true
    this.depositAcc.forEach((d) => {
      if (d.bankId == "" ||
        d.amount == null ||
        (d.shared && (d.percent == null || d.percent <= 0))) {
        isValid = false
        return;
      }
    })

    return isValid
  }

  isValidDebtList() {
    if(this.debtAcc == null || this.debtAcc.length == 0){
      return false
    }
    let isValid = true
    this.debtAcc.forEach((d) => {
      if (d.bankId == "" || d.total == null) {
        isValid = false
        return;
      }
    })

    return isValid
  }

  step1FocusOut(index: number) {
    if(this.depositAcc[index].amount == null){
      return
    }

    this.depositAcc[index].amount = this.depositAcc[index].amount.replaceAll(",", "").replace(/\B(?=(\d{3})+(?!\d))/g, ",")
  }

  step2FocusOut(index: number) {
    if(this.debtAcc[index].total == null){
      return
    }

    this.debtAcc[index].total = this.debtAcc[index].total.replaceAll(",", "").replace(/\B(?=(\d{3})+(?!\d))/g, ",")
  }
}



// WEBPACK FOOTER //
// ./src/app/simulator/simulator.component.ts